export enum PhoneType {
  Mobile = 'Mobile',
  Work = 'Work',
  Home = 'Home',
  Other = 'Other',
}

export enum ContentType {
  Asset = 'Asset',
  Audio = 'Audio',
  Avatar = 'Avatar',
  Scene = 'Scene',
  Weapon = 'Weapon',
  Vehicle = 'Vehicle'
}

export enum MetadataType {
  TempFile = 'TempFile',
  SystemFile = 'SystemFile',
  MessageFile = 'MessageFile',
  PersonFile = 'PersonFile',
  SessionFile = 'SessionFile',
  ContentItemFile = 'ContentItemFile'
}

export enum BackgroundWorkType {
  RebuildAdminGeneric = 'RebuildAdminGeneric',
}

export enum BackgroundWorkStatus {
  Pending = 'Pending',
  Creating = 'Creating',
  InProgress = 'InProgress',
  TimedOut = 'TimedOut',
  Complete = 'Complete',
  Failed = 'Failed',
}

export enum Gender {
  PreferToSelfDescribe = 'PreferToSelfDescribe',
  Male = 'Male',
  Female = 'Female',
  NonBinary = 'NonBinary',
}

export enum PrimaryHand {
  Left = 'Left',
  Right = 'Right',
}